
export const companyCalendar_info = 'The company calendar provides us with a central place for sharing company-wide events and notifying others of your availability. The calendar can be accessed from either Outlook or Teams.'

export const companyCalendar_md = `
# Company Calendar
*Last updated on July 14, 2025*

## Overview

The company calendar provides us with a central place for sharing company-wide events and notifying others of your availability.
The calendar can be accessed from either Outlook or Teams.

Note: due to our current implementation of the company calendar, it is not available on the Outlook and Teams mobile apps.

## Benefits
- **Simple To Use**: Events can be easily added to and updated on the calendar.
- **Seamless Integration**: The calendar displays alongside your personal calendar allowing for you to view conflicting events.
- **Keeps People Informed**: You can easily check on if someone is out of office or available to chat.

## Requirements
- Outlook classic (for initial installation)
- An up to date version of Windows

## Getting Started
1. Open up Outlook Classic
    - Please note that due to our current implementation of the company calendar (Public Folder), it cannot be installed on the new Outlook
    - However, once installed, it can be accessed and interacted with on the new Outlook.
2. Click the Apps icon on the left side bar then click the Folders tile
3. Expand the Public Folders menu
    - Expand the All Public Folders menu
    - Expand the BockPublicFolders menu
4. Right click Company Calendar and add it to favorites
    - After doing this, it should show up in your calendars tab under the Other Calendars menu.

## Support
- Contact our [IT Help Desk](https://it.bockwaterheaters.com/#/help)

`